module.exports = __webpack_public_path__ + "img/Back.c78124d6.svg";